"use client"
import React, { forwardRef, useRef, useImperativeHandle, useCallback, Ref, ChangeEvent } from "react";
import cn from "classnames";
import { isEmpty, noop } from "lodash";
import { TextfieldProps } from ".";
import Styles from "./forms.module.scss";

export const Textfield = forwardRef(({
  size = "md",
  stretch,
  customClass,
  klass,
  type,
  onChange,
  setValid = noop,
  autoComplete,
  error = false,
  ...props
}: TextfieldProps, ref: Ref<HTMLInputElement | null>) => {

  const field = useRef<HTMLInputElement | null>(null);
  useImperativeHandle<HTMLInputElement | null, HTMLInputElement | null>(ref, () => field.current);

  const classes = cn(
    customClass || Styles.textfield,
    klass,
    size,
    {
      error,
      "w-full": stretch,
    }
  );

  const checkEmail = useCallback(() => {
    if (field.current) {
      if (isEmpty(field.current.value)) {
        setValid(true);
        return;
      }
      // simple email check
      setValid(/\S+@\S+\.\S+/.test(field.current.value));
    }
  }, [setValid]);

  const _onChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    if (type === "email") {
      checkEmail();
    }
    onChange?.(e as ChangeEvent<HTMLInputElement>);
  }, [onChange, checkEmail, type]);

  return (
    <input
      ref={field}
      className={classes}
      type={type}
      autoComplete={autoComplete || (type==="email" ? "email" : "")}
      onChange={_onChange}
      {...props}
    />
  );
});
Textfield.displayName = "Textfield";

export default Textfield;
